<template>
  <div id="admin_businesses_no_verify_docs_list">
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.owners_name`]="{ item }">
        {{item.user.first_name}} {{item.user.last_name}} 
      </template>
      
      <template v-slot:[`item.is_verified`]="{ item }">
        <span class="red--text" v-if="parseInt(item.is_verified) == 0"
          ><b>Pending</b></span
        >
        <span class="blue--text" v-if="parseInt(item.is_verified) == 1"
          ><b>Processing</b></span
        >
        <span class="green--text" v-if="parseInt(item.is_verified) == 2"
          ><b>Verified</b></span
        >
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminBusinessesNoVerifyDocs",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      items: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Owner",
          align: "start",
          sortable: true,
          value: "owners_name",
          filterable: true,
        },
        {
          text: "User Name",
          align: "start",
          sortable: true,
          value: "user.email",
          filterable: true,
        },
        {
          text: "Join Date",
          align: "start",
          sortable: true,
          value: "joined_on",
          filterable: true,
        },
        {
          text: "Verification",
          align: "start",
          sortable: true,
          value: "is_verified",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_buinesses_without_verification_docs(
        {
        },
        (res) => {
          this.items = res;
          this.$emit("on-hide-loader");
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading busineeses on admin no verification docs businesses list",
            errors
          );
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/businesses/list/view/" + item.id);
    },
  },
  mounted() {
      
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if is not admin please redirect this user to the login screen
    
    this.$emit("set-page-attributes", {
      title: "Businesses Missing Verify Docs",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/admin/businesses",
        },
        {
          text: "No Docs List",
          disabled: true,
          href: "/admin/businesses/reports/verify/nodocs",
        },
      ],
    });
    this.load_items();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_businesses_no_verify_docs_list", options);
  },
};
</script>